import dayjs from 'dayjs';
import { excuseApi } from "../commons/http";
import Package from './package';
import Order from './order';

class UserPackage {
  constructor(data = {}) {
    this.mapData(data);
  }

  mapData(data) {
    this.id = data.id;
    this.package_id = data.package_id;
    this.user_id = data.user_id;
    this.note = data.note;
    this.beginning_date = data.beginning_date;
    this.ending_date = data.ending_date;
    this.financial_status = data.financial_status;
    this.status = data.status;
    this.sending_invoice_status = data.sending_invoice_status;
    this.sent_invoice_at = data.sent_invoice_at;
    this.user = data.user;
    this.package = new Package(data.package);

    // Actor fields
    this.created_by_account_id = data.created_by_account_id;
    this.updated_by_account_id = data.updated_by_account_id;
    this.sent_invoice_by_account_id = data.sent_invoice_by_account_id;
    this.created_by = data.created_by;
    this.updated_by = data.updated_by;
    this.sent_invoice_by = data.sent_invoice_by;

    // Map orders if present in API response
    this.orders = data.orders ? data.orders.map(orderData => {
      const order = new Order();
      order.mapData(orderData);
      return order;
    }).sort((a, b) => {
        // Sort by processed_at in descending order (newest first)
        if (!a.processed_at) return 1;  // Null values go to end
        if (!b.processed_at) return -1;
        return new Date(b.processed_at) - new Date(a.processed_at);
      }) : [];

    // Map bonuses if present in API response
    this.bonuses = data.bonuses || [];
    this.bonus_total = data.bonus_total || 0;
  }

  async getById(id) {
    try {
      const res = await excuseApi({
        path: `/user-packages/${id}`,
        method: 'GET',
      });
      if (res.status === 200) {
        this.mapData(res.data.data);
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }

  async save() {
    try {
      const res = await excuseApi({
        path: '/user-packages',
        method: 'POST',
        body: {
          package_id: this.package_id,
          user_id: this.user_id,
          note: this.note,
          beginning_date: dayjs(this.beginning_date).format('YYYY-MM-DDTHH:mm:ssZ'),
          financial_status: this.financial_status,
          status: this.status,
          sending_invoice_status: this.sending_invoice_status,
        }
      });
      return res.status === 201;
    } catch (error) {
      throw error;
    }
  }

  async getActivePackageByUserId(userId) {
    try {
      const res = await excuseApi({
        path: `/users/${userId}/active-package`,
        method: 'GET',
      });
      if (res.status === 200 && res.data.data) {
        return res.data.data;
      }
      return null;
    } catch (error) {
      throw error;
    }
  }

  async update() {
    try {
      const res = await excuseApi({
        path: `/user-packages/${this.id}`,
        method: 'PUT',
        body: {
          package_id: this.package_id,
          user_id: this.user_id,
          note: this.note,
          beginning_date: dayjs(this.beginning_date).format('YYYY-MM-DDTHH:mm:ssZ'),
          ending_date: dayjs(this.ending_date).format('YYYY-MM-DDTHH:mm:ssZ'),
          financial_status: this.financial_status,
          status: this.status,
          sending_invoice_status: this.sending_invoice_status,
        }
      });
      if (res.status === 200) {
        this.mapData(res.data.data);
        return true;
      }
      return false;
    } catch (error) {
      throw error;
    }
  }
}

export default UserPackage;
